// Ce fichier est généré automatiquement - ne pas modifier manuellement
// Utilisez 'node scripts/generate-media-list.js' pour le régénérer

export const generatedMediaList = [
  {
    "id": "image-1",
    "name": "demo.png",
    "type": "image",
    "category": "custom",
    "path": "/media/images/demo.png",
    "size": "9.6 MB",
    "dimensions": "1280x720",
    "uploadDate": "2025-06-20T16:16:26.114Z",
    "tags": [
      "nouveau",
      "ajouté"
    ]
  },
  {
    "id": "video-2",
    "name": "MENU Dej.mp4",
    "type": "video",
    "category": "menu",
    "path": "/media/videos/MENU Dej.mp4",
    "size": "40.8 MB",
    "duration": "1:00",
    "uploadDate": "2025-06-20T16:16:26.115Z",
    "tags": [
      "menu",
      "nouveau",
      "ajouté"
    ]
  }
];
